import { notificationIdentity } from '../../definitions/NotificationConstants';
import Logger from '../../utils/Logger';
import { find } from 'lodash';
import { BACKENDNOTIFICATIONS } from '../reducer';
import { navigateToTimelineFrameFimlab } from "../../views/timelineframe/data/actions";
import {laboratoryNotificationIdFromNotificationItem} from "../../views/timeline/data/selector";

let createActionName = require('../util').createActionName('notification');

let { id: module_id } = module;
const logger = new Logger(module_id);

export const getNotifications = () => ({
  type: GET_NOTIFICATIONS,
});

export const receiveNotifications = (data) => ({
  type: RECEIVE_NOTIFICATIONS,
  data: data,
});

export const getNotificationsFailed = (error) => ({
  type: GET_NOTIFICATIONS_FAILED,
  error: error,
});

export const GET_NOTIFICATIONS = createActionName('GET_NOTIFICATIONS');
export const RECEIVE_NOTIFICATIONS = createActionName('RECEIVE_NOTIFICATIONS');
export const GET_NOTIFICATIONS_FAILED = createActionName(
  'GET_NOTIFICATIONS_FAILED'
);

export const REQUEST_DISMISS_NOTIFICATIONS = createActionName(
  'REQUEST_DISMISS_NOTIFICATIONS'
);
export const REQUEST_DISMISS_NOTIFICATIONS_FAILED = createActionName(
  'REQUEST_DISMISS_NOTIFICATIONS_FAILED'
);

export const doGetNotifications = () => (dispatch, getState, services) => {
  return new Promise((resolve, reject) => {
    dispatch(getNotifications());
    services.api
      .getNotifications()
      .then((data) => {
        resolve(dispatch(receiveNotifications(data)));
      })
      .catch((error) => {
        reject(dispatch(getNotificationsFailed(error)));
      });
  });
};

export const requestDismissNotifications = (notifications) => ({
  type: REQUEST_DISMISS_NOTIFICATIONS,
  notifications,
});

export const requestDismissNotificationsFailed = (error) => ({
  type: REQUEST_DISMISS_NOTIFICATIONS_FAILED,
  error,
});

const findNotifications = (identities, data) => {
  return data.filter((item) => {
    return find(
      identities,
      (identity) => identity === item[notificationIdentity]
    );
  });
};

export const doRequestDismissNotifications = (identities) => (dispatch) => {
  dispatch(doRequestDismissNotificationsList([identities]));
};

export const doRequestDismissNotificationsList =
  ([identities]) =>
  (dispatch, getState, services) => {
    let notifications = findNotifications(
      identities,
      getState()[BACKENDNOTIFICATIONS].data
    );

    return new Promise((resolve, reject) => {
      dispatch(requestDismissNotifications(notifications));
      services.api
        .dismissNotifications({ notifications: notifications })
        .then((data) => {
          // could this just reuse "receiveNotifications" ?
          dispatch(receiveNotifications(data));
          resolve(dispatch(navigateToTimelineFrameFimlab(laboratoryNotificationIdFromNotificationItem(notifications[0]))));
        })
        .catch((error) => {
          reject(dispatch(requestDismissNotificationsFailed(error)));
        });
    });
  };

export const GET_GLOBAL_NOTIFICATIONS = createActionName(
  'GET_GLOBAL_NOTIFICATIONS'
);
export const RECEIVE_GLOBAL_NOTIFICATIONS = createActionName(
  'RECEIVE_GLOBAL_NOTIFICATIONS'
);
export const GET_GLOBAL_NOTIFICATIONS_FAILED = createActionName(
  'GET_GLOBAL_NOTIFICATIONS_FAILED'
);

export const getGlobalNotifications = () => ({
  type: GET_GLOBAL_NOTIFICATIONS,
});

export const receiveGlobalNotifications = (data) => ({
  type: RECEIVE_GLOBAL_NOTIFICATIONS,
  data: data,
});

export const getGlobalNotificationsFailed = (error) => ({
  type: GET_GLOBAL_NOTIFICATIONS_FAILED,
  error: error,
});

export const doGetGlobalNotifications =
  () => (dispatch, getState, services) => {
    return new Promise((resolve, reject) => {
      dispatch(getGlobalNotifications());
      services.api
        .getGlobalNotifications()
        .then((data) => {
          resolve(dispatch(receiveGlobalNotifications(data)));
        })
        .catch((error) => {
          reject(dispatch(getGlobalNotificationsFailed(error)));
        });
    });
  };
